<template>
  <page-view class="page-contract-search tms-style points-mall">
    <div slot="pageRight">
      <div class="order-list banner">
        <div class="integral">
          <span>{{ $t('PointsMall.RemainingPoints') }}:</span>
          <span>{{ userPoints }}</span>
          <span @click="handleToPointsOrder">{{
            $t('PointsMall.ExchangeHistory')
          }}</span>
        </div>
        <img
          v-if="$ls.get('lang') == 'zh'"
          src="@/assets/images/pointsMall/banner.jpg"
        />
        <img v-else src="@/assets/images/pointsMall/banner_en.jpg" />
      </div>
      <div class="sort-wrap">
        <ProductSort
          ref="storeProductSort"
          :show-own-checkbox="false"
          @searchList="searchList"
        />
      </div>
      <div class="order-list">
        <el-alert :title="title" :closable="false" type="info" show-icon>
        </el-alert>
        <p class="title">{{ $t('PointsMall.TheGifts') }}</p>
        <div class="goods-container">
          <GoodsItem
            v-for="item in goodsList"
            :key="item.ID"
            :goods-item="item"
            @conversion="handleShowDialog"
          />
          <div
            v-if="!goodsList || goodsList.length == 0"
            style="text-align: center; padding: 20px"
          >
            {{ $t('PointsMall.GiftExchange') }}
          </div>
        </div>
        <p class="title">{{ $t('PointsMall.TheService') }}</p>
        <div class="server-class">
          <GoodsItem
            v-for="item in serverList"
            :key="item.ID"
            :goods-item="item"
            @conversion="handleShowDialog"
          />
          <!-- <ServerClassItem
            v-for="(item, index) in serverList"
            :key="item.ID"
            :server-index="index"
            :server-item="item"
            @conversion="handleShowDialog"
          /> -->
        </div>
      </div>
      <ExchangeModal
        ref="exchangeModal"
        :goodsType="goodsType"
        :selectedItem="selectedItem"
        @submitSuccess="getCustomerPointsInfo()"
      />
      <el-dialog
        :title="$t('PointsMall.InputInformation')"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        width="500px"
      >
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            :loading="loading"
            label-width="160px"
            class="demo-ruleForm exchange-form-dialog"
          >
            <el-form-item
              :label="$t('PointsMall.ContactPerson')"
              prop="ContactsName"
            >
              <el-input
                v-model="ruleForm.ContactsName"
                :placeholder="$t('InvoiceInquiry.PleaseEnter')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('PointsMall.TelephoneNumber')"
              prop="ContactsPhone"
            >
              <el-input
                v-model="ruleForm.ContactsPhone"
                :placeholder="$t('InvoiceInquiry.PleaseEnter')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('PointsMall.ExchangeNumber')" prop="Num">
              <el-input
                type="number"
                v-model="ruleForm.Num"
                :placeholder="$t('InvoiceInquiry.PleaseEnter')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('PointsMall.DeliveryAddress')"
              prop="ShippingAddress"
              v-if="goodsType == 1"
            >
              <el-input
                v-model="ruleForm.ShippingAddress"
                :placeholder="$t('InvoiceInquiry.PleaseEnter')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('PointsMall.Remark')" prop="Remark">
              <el-input
                type="textarea"
                v-model="ruleForm.Remark"
                :placeholder="$t('InvoiceInquiry.PleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{
            $t('ServiceEvaluation.Cancel')
          }}</el-button>
          <el-button type="primary" :loading="loading" @click="handleSubmit">{{
            $t('ServiceEvaluation.Confirm')
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import GoodsItem from './components/GoodsItem'
import ServerClassItem from './components/ServerClassItem'
import ExchangeModal from './components/exchangeModal'
import ProductSort from './components/productSort'
import { USER_INFO } from '@/store/mutation-types'
import { submitOrder, getCustomerPointsInfo, getProductsPageListJson } from '@/api/pointsMall'
import i18n from '@/i18n/i18n'

export default {
  name: 'PointsMall',
  components: { PageView, GoodsItem, ServerClassItem, ExchangeModal, ProductSort },
  data() {
    return {
      title: i18n.t('PointsMall.ExplanationOfRules'),
      goodsList: [],
      serverList: [],
      ruleForm: {},
      rules: {
        ContactsName: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
        ContactsPhone: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
        Num: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
        ShippingAddress: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
      },
      dialogVisible: false,
      goodsType: 1,
      selectedItem: {},
      userPoints: 0,
      loading: false
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
  },
  mounted() {
    this.getProductsPageListJson()
    this.getCustomerPointsInfo()
  },
  methods: {
    handleClose() {
      if (this.dialogVisible) {
        this.$refs.ruleForm.resetFields()
      }
      this.loading = false
      this.dialogVisible = !this.dialogVisible
    },
    handleShowDialog(val, type) {
      this.selectedItem = val
      this.goodsType = type
      // this.handleClose()
      this.$refs.exchangeModal.handleClose()
    },
    goToDetail(record) {
      this.$router.push({
        name: 'productDetail',
        query: {
          pid: record.ID
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$confirm(i18n.t('PointsMall.filledInIsCorrect'), i18n.t('ChangePassword.Prompt'), {
            confirmButtonText: i18n.t('ServiceEvaluation.Confirm'),
            cancelButtonText: i18n.t('ServiceEvaluation.Cancel'),
            type: 'warning'
          }).then(() => {
            submitOrder({
              CustomerID: this.userInfo.CACode,
              CustomerName: this.userInfo.CAName,
              ProductID: this.selectedItem.ID,
              ProductName: this.selectedItem.CommodityName,
              ProductSpecifications: this.selectedItem.Specifications,
              CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
              // UseIntegral: this.goodsType == 1 ? this.selectedItem.Integral : '',
              ...this.ruleForm
            }).then(res => {
              if (res.code == 200) {
                this.handleClose()
                this.getCustomerPointsInfo()
                this.$message({
                  type: 'success',
                  message: i18n.t('PointsMall.SubmissionSuccessful')
                })
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }).catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: i18n.t('HistoricalRedemptionRecords.Canceled')
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    getCustomerPointsInfo() {
      getCustomerPointsInfo({
        customerID: this.userInfo.CACode,
        CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
      }).then(res => {
        if (res.code == 200) {
          this.userPoints = res.effectiveValue
        }
      })
    },
    getProductsPageListJson(priceFilter = {}) {
      const params = {
        ...priceFilter,
        CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
        PageIndex: 1,
        Pagesize: 1000
      }
      getProductsPageListJson(params).then(res => {
        console.log(res, 111111)
        if (res.code == 200) {
          const goodsList = [], serverList = []
          res.rows.map(item => {
            if (item.CommodityType == 0) {
              goodsList.push(item)
            } else {
              serverList.push(item)
            }
          })
          this.goodsList = [...goodsList]
          this.serverList = [...serverList]
        }
        console.log(this.goodsList, this.serviceList)
      })

    },
    handleToPointsOrder() {
      this.$router.push({
        name: 'exchangeRecord'
      })
    },
    searchList(query) {
      if (query && query.prange) {
        const obj = {
          Min_DetailIntegral: query.prange.split('-')[0] ? Number(query.prange.split('-')[0]) : undefined, // 积分范围最小值
          Max_DetailIntegral: query.prange.split('-')[1] ? Number(query.prange.split('-')[1]) : undefined, // 积分范围最大值
        }
        this.getProductsPageListJson(obj)
      } else {
        this.getProductsPageListJson({})
      }
      console.log('query', query)
    },
  }
}
</script>
<style lang="less">
.page-contract-search {
  padding: 10px;
  background: #f0f6fb;
  .banner {
    position: relative;
    img {
      width: 100%;
    }
    .integral {
      position: absolute;
      top: 28px;
      right: 140px;
      display: flex;
      align-items: center;
      & > span {
        color: #f96364;
      }
      & > span:nth-child(2) {
        font-size: 22px;
        margin-bottom: 3px;
      }
      & > span:nth-child(1) {
        font-size: 14px;
        color: #000;
        text-align: right;
        margin-right: 10px;
      }
      & > span:nth-child(3) {
        font-size: 14px;
        color: #000;
        text-align: right;
        margin-left: 10px;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .sort-wrap {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    // min-height:60vh;
    .list-item {
      margin-bottom: 8px;
    }
    .goods-container,
    .server-class {
      display: flex;
      margin-bottom: 10px;
      flex-wrap: wrap;
      > div {
        padding: 10px;
        margin-right: 20px;
        margin-bottom: 15px;
        &:hover {
          border-color: rgba(0, 0, 0, 0.09);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
        }
      }
    }
    // .server-class {
    //   display: grid;
    //   /* grid-gap: 30px 50px */
    //   grid-column-gap: 10px;
    //   grid-row-gap: 15px;

    //   grid-template-columns: auto auto auto;
    // }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .table_content {
    margin-top: 20px;
  }
  .el-loading-mask {
    z-index: 1000;
  }
  .el-alert--info.is-light {
    background: #e7f6ff;
    color: #54abc3;
    margin-bottom: 10px;
  }
  .exchange-form-dialog {
    .el-input__inner,
    .el-textarea__inner {
      border: 1px solid #dcdfe6;
      background: #ffffff;
    }
  }
}
.el-form-item__error {
  position: relative;
}
.ant-message {
  z-index: 99999;
}
</style>
